import Http from "./http";

export default {
  destroy: async file_id => {
    let data = await Http.delete(`/questsubmissionfiles/${file_id}`);
    return data;
  },
  create: async formData => {
    let data = await Http.post(`/questsubmissionfiles`, formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      },
      timeout: 0
    });
    return data;
  }
};
